import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePartyAuth } from '../contexts/PartyAuthContext';
import client from '../api/client';

export default function PartyAnalytics() {
  const { party } = usePartyAuth();
  const navigate = useNavigate();
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!party) { navigate('/party/login'); return; }
    client.get('/party/analytics').then(res => {
      setAnalytics(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [party, navigate]);

  const maxVotes = analytics?.by_constituency?.reduce((max, c) => Math.max(max, parseInt(c.vote_count)), 0) || 1;

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Analytics</h1>
        <Link to="/party/dashboard" className="btn-secondary">Back</Link>
      </div>

      {loading ? <p>Loading...</p> : (
        <>
          <div className="card">
            <h2>Votes by Constituency</h2>
            {analytics?.by_constituency?.length === 0 && <p>No votes recorded yet.</p>}
            <div className="bar-chart">
              {analytics?.by_constituency?.map(c => (
                <div key={c.constituency_name} className="bar-row">
                  <div className="bar-label">{c.constituency_name}</div>
                  <div className="bar-track">
                    <div
                      className="bar-fill"
                      style={{ width: `${(parseInt(c.vote_count) / maxVotes) * 100}%` }}
                    />
                  </div>
                  <div className="bar-value">{c.vote_count}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="card">
            <h2>Votes Over Time (per second)</h2>
            {analytics?.by_second?.length === 0 && <p>No voting activity yet.</p>}
            <div className="timeline-chart">
              {analytics?.by_second?.map((entry, idx) => (
                <div key={idx} className="timeline-entry">
                  <span className="timeline-time">{new Date(entry.second).toLocaleTimeString()}</span>
                  <span className="timeline-count">{entry.count} votes</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
